export default __webpack_public_path__ + "static/media/SourceSansPro-BoldItalic.a1af9506.eot";